export const getTaskFormDraftKey = (projectId = 0, taskListId = 0, taskId = 0) => {
  return `project_${projectId}_task_list_${taskListId}_task_${taskId}`;
};
